export const mapValueObjectsToOptions = (values) =>
  values.map((value) => ({ value: value.value, label: value.display_value }));

export const mapValuesToOptions = (values) =>
  values.map((value) => ({ value, label: value }));

export const mapOptionsToValues = (options) =>
  options.map((option) => option.value);
